(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature-user-group-map', {
            parent: 'entity',
            url: '/application-feature-user-group-map',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureUserGroupMap.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map.html',
                    controller: 'ApplicationFeatureUserGroupMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureUserGroupMap');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-user-group-map-detail', {
            parent: 'entity',
            url: '/application-feature-user-group-map/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureUserGroupMap.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-detail.html',
                    controller: 'ApplicationFeatureUserGroupMapDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureUserGroupMap');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeatureUserGroupMap', function($stateParams, ApplicationFeatureUserGroupMap) {
                    return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature-user-group-map.new', {
            parent: 'application-feature-user-group-map',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('application-feature-user-group-map');
                });
            }]
        })
        .state('application-feature-user-group-map.edit', {
            parent: 'application-feature-user-group-map',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeatureUserGroupMap', function(ApplicationFeatureUserGroupMap) {
                            return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature-user-group-map.delete', {
            parent: 'application-feature-user-group-map',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-delete-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeatureUserGroupMap', function(ApplicationFeatureUserGroupMap) {
                            return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
